import {
    Dialog,
    ModalBody,
    ModalErrorBanner,
    ModalHeader,
    ModalTitle
} from 'app/components/core/Modal';
import * as styles from './DialogWithChapters.css';

const DIALOG_WIDTH = 800;
const DIALOG_HEIGHT = 500;

export function DialogSidebar({ children }) {
    return <div className={styles.sidebar}>{children}</div>;
}

export function DialogFormContent({ children }) {
    return <div className={styles.formContent}>{children}</div>;
}

export function DialogWithChapters({ children, title, error, onClose, id, height }) {
    return (
        <Dialog
            id={id}
            width={DIALOG_WIDTH}
            height={height ?? DIALOG_HEIGHT}
            onClose={onClose}
            isResizable>
            <ModalHeader>
                <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            {error && <ModalErrorBanner error={error} />}
            <ModalBody className={styles.sidebarLayout}>{children}</ModalBody>
        </Dialog>
    );
}
